export const ROUTES = {
  DASHBOARD:  '/',
  METRICS:    '/metrics',
  SCHEDULING: '/scheduling',
  EVENT_LOG:  '/event-log',
  JOYSTICK:   '/joystick',
} as const;

export const NAV_ITEMS = [
  { label: 'Dashboard',  path: ROUTES.DASHBOARD },
] as const;

export const NAV_ITEMS_AUTHED = [
  { label: 'Event Log', path: ROUTES.EVENT_LOG },
] as const;
